// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2tmr-","footer":"ModalInfo_footer__2xLm-"};